import { Popover } from "antd";
import React from "react";
import pluralize from "pluralize";
import _ from "lodash";
/**
 *
 * @param items
 * @param label
 * @param labels plural form
 * @return {*}
 * @constructor
 */
const Tag = ({ items = [], data={}, label = "" }) => {
	const nbItems = items.length;
	const content = (
		<div>
			{items.map((item, index) => {
				const itemObj = _.find(data, {id:item}) || {}
				return (
					<div key={index} style={{ margin: 5 }}>
						{itemObj.value}
					</div>
				);
			})}
		</div>
	);

	return (
		<Popover content={content}>
			<div>{`${nbItems} ${
				nbItems > 1 ? pluralize(label) : pluralize.singular(label)
			}`}</div>
		</Popover>
	);
};

export default Tag;



// WEBPACK FOOTER //
// src/components/filter/Tag.js